import { cn } from "../../../lib/cn";
import { buttonVariants } from "../../button";
import {
	SQ_PRIMARY_CTA_GRADIENT_ACTIVE_CLASS,
	SQ_PRIMARY_CTA_GRADIENT_CLASS,
} from "../../../lib/sq-color-runtime-exports";

import {
	CTA_PRIMARY_ELEVATION_CLASS,
	CTA_SURFACE_TRANSITION_CLASS,
} from "./cta-surface-classes";

/** Shared large CTA footprint (no elevation — pair with surface-specific elevation). */
export const PRIMARY_CTA_FOOTPRINT_CLASS = cn(
	"min-w-[10rem]",
	"h-auto",
	"rounded-xl px-5 py-4 text-center text-base font-black uppercase tracking-wide leading-none",
);

/**
 * Default `RippleButton` `className` for primary CTAs (amber gradient when `appearance` is default).
 */
export const PRIMARY_CTA_CLASSNAME = cn(
	PRIMARY_CTA_FOOTPRINT_CLASS,
	CTA_PRIMARY_ELEVATION_CLASS,
);

/** Shared primary slotted / visual chrome (gradient + hover lift without stop interpolation). */
export const PRIMARY_CTA_GRADIENT_CHROME_CLASS = cn(
	SQ_PRIMARY_CTA_GRADIENT_CLASS,
	SQ_PRIMARY_CTA_GRADIENT_ACTIVE_CLASS,
	"text-amber-950 hover:text-amber-950 active:text-amber-950",
	"disabled:cursor-not-allowed disabled:opacity-60 disabled:saturate-50",
);

/**
 * Non-interactive surface matching {@link import("./primary-cta").PrimaryCta} (gradient + scale motion on a parent `RippleButton`).
 * Use with `pointer-events-none` on this surface so the parent `RippleButton` handles clicks
 * (avoids a nested button inside the tile’s outer button).
 */
export function primaryCtaVisualClassName(overrides?: string): string {
	return cn(
		"inline-flex min-w-0 select-none items-center justify-center",
		PRIMARY_CTA_GRADIENT_CHROME_CLASS,
		buttonVariants({ variant: "ghost", size: "md" }),
		PRIMARY_CTA_CLASSNAME,
		"relative cursor-default overflow-hidden",
		CTA_SURFACE_TRANSITION_CLASS,
		overrides,
	);
}
